import {
    Component, HostListener, Input, OnInit
} from '@angular/core';
import { HttpService } from '../../services/http.service';

import { CfAlertService } from '@crediblefinance/credible-ui';
import { WalletService } from '../../services/wallet.service';
import { LocalStorageService } from '../../services/localstorage.service';
import {
    ActivatedRoute, NavigationEnd, Router
} from '@angular/router';
import { PhantomService } from '../../services/phantom.service';
import { SolflareService } from '../../services/solflare.service';
import User from '../../models/User';
import { getWindow } from 'ssr-window';
import { HttpErrorResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { MetamaskService } from '../metamask.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: [ './header.component.scss' ]

})
export class HeaderComponent implements OnInit {
    total_usd: number = 0;
    hidden_string: string = '';
    width: any;
    window: Window;
    toggle: boolean = false;

    showCredibleLogo: boolean = false;
    current_url: string = '';
    tvl_usd = 0;
    displayConnectWalletButton: boolean = true;
    @Input() showConnectWallet: boolean = true;
    themeClasses: Array<string> = [];

    constructor(public httpService: HttpService,
        private cfAlertService: CfAlertService,
        public walletService: WalletService,
        private localStorageService: LocalStorageService,
        private router: Router,
        private phantomService: PhantomService,
        private solflareService: SolflareService,
        private metamaskService: MetamaskService
    ) {
        this.window = getWindow();
    }

    isMenuCollapsed: boolean = true;

    @HostListener('window:resize', [ '$event' ])
    onResize(event: any) {
        this.width = event.target.innerWidth;
    }

    ngOnInit(): void {
        this.width = this.window.innerWidth;

        this.setBackgroundClass();

        if (this.router.url === '/login' || this.router.url.includes('/login') || this.httpService.user.user_id > 0)
            this.displayConnectWalletButton = false;

        this.subscribeRouteChangeEvents();
        this.subscribeThemeChanges();
        this.getHomepageStats();
    }

    scrollToSection(sectionId: string): void {
        const element = document.getElementById(sectionId);

        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }

    redirectToUrl(url: any) {
        this.window.open(url, '_blank');
    }

    subscribeRouteChangeEvents() {
        this.current_url = this.window.location.pathname;

        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
            this.current_url = this.window.location.pathname;

            if (this.current_url === '/login' || this.httpService.user.user_id > 0)
                this.displayConnectWalletButton = false;

            this.setBackgroundClass();
        });
    }

    subscribeThemeChanges() {
        this.httpService.themeChanged.subscribe((theme: string) => {
            this.setBackgroundClass();
        });
    }

    getChild(activatedRoute: ActivatedRoute): ActivatedRoute {
        if (activatedRoute.firstChild)
            return this.getChild(activatedRoute.firstChild);

        else
            return activatedRoute;
    }

    connectWallet() {
        this.httpService.redirectUrl(this.constructor.name, '/login', {
            skipLocationChange: true,
            queryParams: {
                returnUrl: this.router.url
            }
        });
    }

    getHiddenString() {
        const hidden_string = this.total_usd.toFixed(2);

        return hidden_string.replace(/[0-9]/g, 'X');
    }

    addressExists(wallet_address: string) {
        if (wallet_address === '')
            return false;

        return true;
    }

    closeNavbar() {
        this.isMenuCollapsed = true;
    }

    gotoURL(url: string) {
        this.router.navigate([ url ]);
    }

    async logout() {
        console.log('logout', this.constructor.name);

        if (this.walletService.current_provider === 'phantom')
            this.phantomService.disconnectWallet();

        else if (this.walletService.current_provider === 'solflare')
            this.solflareService.disconnectWallet();

        else if (this.walletService.current_provider === 'metamask')
            this.metamaskService.disconnectWallet();

        this.walletService.wallet_address = '';
        this.walletService.current_provider = '';

        this.localStorageService.clear();

        this.httpService.user = new User();

        await this.router.navigate([ '/' ], {
            replaceUrl: true
        });

        console.log('RELOAD ISSUE URL : HeaderComponent => ', this.window.location.href);

        this.window.location.reload();
    }

    redirectToDashboard() {
        if (this.httpService.user.user_id === 0)
            this.httpService.redirectUrl(this.constructor.name, '/login');

        else
            this.router.navigate([ '/dashboard' ]);
    }
    getHomepageStats() {
        this.httpService.getHomepageStats().subscribe(res => {
            this.tvl_usd = res.data.tvl_usd;
        }, (err: HttpErrorResponse) => {
            console.error(err);

            this.cfAlertService.showError(err);
        });
    }

    setBackgroundClass() {
        if (this.httpService.theme === 'dark') {
            if (this.current_url === '/')
                this.themeClasses = [ 'black-background', this.httpService.theme ];

            else
                this.themeClasses = [ 'grey-background', this.httpService.theme ];
        }

        else {
            if (this.current_url === '/')
                this.themeClasses = [ 'white-background', this.httpService.theme ];

            else
                this.themeClasses = [ 'lightgrey-background', this.httpService.theme ];
        }
    }
}
